<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol >
                    <h1 class="page__title">{{ title_page }}</h1>
                </CCol>
                <CCol
                    class="d-flex justify-content-end"
                >
                    <ButtonCreate
                        :title="$t('new_import')"
                        @click="
                            $router.push({
                                name: 'import',
                            })
                        "
                    >
                        {{ $t("create_import") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields 
                            :fields="tables.imports.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CCardHeader>                    
                    <div class="d-flex">
                        <TableSettings
                            :allFields="tables.imports.allFields"
                            :activeFields.sync="tables.imports.fields"
                        />
                    </div>
                </CCardHeader>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.imports.items"
                                    :fields="traslateArrayObjects({ 
                                        array:tables.imports.fields,
                                        fields:['label']
                                    })"
                                    :itemsPerPageSelect="{
                                        values:[5, 10, 20],
                                    }"
                                    :columnFilterValue.sync="tables.imports.columnFilterValue"
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.imports.rows"
                                    v-bind="tables.imports"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="$t('actions')"
                                                    class="m-2"
                                                    :disabled="tables.imports.itemSelected === null"
                                                >
                                                    <CDropdownItem
                                                            tag="div"
                                                            class="text-cent\er"
                                                            @click="
                                                                $router.push({
                                                                    name: 'import_logs',
                                                                    query: { uuid: tables.imports.itemSelected.uuid },
                                                                })
                                                            "
                                                        >
                                                    <strong>{{ $t("see_logs") }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                            tag="div"
                                                            class="text-cent\er"
                                                            :disabled="
                                                            tables.imports.itemSelected.total 
                                                            == tables.imports.itemSelected.send || isDisabled"
                                                            @click="eventSynchronizeImport(tables.imports.itemSelected.uuid)"
                                                            v-if="
                                                            tables.imports.itemSelected
                                                            "
                                                        >
                                                    <strong>{{ $t("reload") }}</strong>
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #no-items-view>
                                        <slot name="no-items-view">
                                            <div class="block-no-items section">
                                                <!-- <span class="emoji">&#128557;</span> -->
                                                <br />
                                                <h2
                                                    class="
                                                        section__title
                                                        text-no-items
                                                    "
                                                >
                                                    {{
                                                        $t(
                                                            "no-items-text.imports"
                                                        )
                                                    }}
                                                </h2>
                                            </div>
                                        </slot>
                                    </template>
                                    <template #_selected="{item}">
                                        <td class="py-2">
                                            <CInputRadio
                                                :checked="item === tables.imports.itemSelected"
                                                @update:checked="selectItemTable('imports', item)"
                                            />
                                        </td>
                                    </template>
                                    <template #id="{ item }" >
                                        <td>
                                            {{ item.id }}
                                        </td>
                                    </template>
                                    <template #file_name="{ item }" >
                                        <td>
                                            <a :href="item.file_url">
                                                {{ (item.file_name) ? item.file_name:'' }}
                                            </a>
                                        </td>
                                    </template>
                                    <template #activity="{ index }">
                                        <td class="text-center">
                                            <CSpinner grow :color="activity[index]" size="sm" />
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="'imports.api/list'"
                                                :table="tables.imports"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.imports.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.imports.page"
                                        :pages="tables.imports.total_pages"
                                        align="center"
                                    />
                                    <CElementCover :opacity="0.8" class="bg-trasparent" v-if="tables.imports.loading"/>
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
  
</template>

<script>
import FilterDate from "~/components/FilterDate";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import ButtonCreate from "~/components/ButtonCreate";
import { cilPlus, cilSettings, cilReload, cilPencil, cilChart , cilTrash, cilArrowThickFromRight, cilMediaPlay, cilMediaStop } from '@coreui/icons';
import { mapGetters } from "vuex";
import pageMixin from '~/mixins/page.js';
import tableMixin from "~/mixins/table.js";
import TableSettings from "£lement/TableSettings";
import ImportTable from './config/tables/imports.js';
export default {
    name:"ImportsPage",
    middleware: ["auth","page"],
    mixins: [ pageMixin, tableMixin ],
    components:{
        FilterDate,
        FilterFields,
        ButtonExport,
        ButtonCreate,
        TableSettings
    },
    icons:{
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
        cilReload,
        cilChart,
        cilMediaPlay,
        cilMediaStop
    },
    data(){
        return{
            tables:{
                imports:ImportTable
            },
            activity:[],
            intervalActivity:null,
            isDisabled: false
        }
    },
    computed:{
        ...mapGetters({
            from:"filter/from",
            to:"filter/to"
        }), 
        title_page:function(){
            return this.$t("imports");
        }
    },
    methods:{
        itemPerPage(newValue){
            this.tables.imports.rows = newValue;
            this.updatePagination(this.tables.imports.page);
        },
        updatePagination(newValue){
            this.tables.imports.page = newValue;
            this.updateData();
        },
        async updateData(){
            await this.updateTable({
                tableName:"imports", 
                url:'/imports.api/list', 
            });
            this.tables.imports.itemSelected = null;
            this.tables.imports.loading = false;
            this.updatePageLoading(false);
        },
        async synchronizeImport(uuid){
            let resp = await this.fetcher({
                url: `/imports.api/sync/${uuid}`,
                method:"PUT"
            });
        },

        async eventSynchronizeImport(uuid){
            this.isDisabled= true;
            await this.synchronizeImport(uuid);
            this.updateData();
            this.isDisabled= false;
        },

        async eventSynchronizeAllImports(){
            let imp = this.tables.imports.items;
            for(let i = 0; i < imp.length; i++){
                const item = imp[i];
                if(parseInt(item.total) != parseInt(item.send)){
                    await this.synchronizeImport(imp[i].uuid);
                }
            }
        },

        async serviceActivityChecker() {
            let items = this.tables.imports.items;
            let activity = [];
            for (let index = 0; index < items.length; index++) {
                const item = items[index];
                if(parseInt(item.total) == parseInt(item.send)){
                    activity.push("secondary");
                }else{
                    let data = await this.fetcher({
                        url:`/import_logs.api/list/${item.uuid}`,
                    });
                    let lastItem = null;
                    let diff = 0;
                    if(data._items.length > 0){
                        lastItem = data._items[data._items.length - 1];
                        let createdAt = new Date(lastItem.created_at);
                        let today = new Date();
                        diff = today.getTime() - createdAt.getTime();
                    }
                    if(lastItem && diff < 8000000){
                        if(lastItem.status == "err"){
                            activity.push("danger");
                        }
                        else
                            activity.push("success");
                    }else{
                        activity.push("secondary");
                    }
                    
                }
            }
            this.activity = activity;
        },


        checkActivity(intervalTime = 60000) {
            this.serviceActivityChecker();
            this.clearIntervalActivity();
            this.intervalActivity = setInterval(() => {
                this.serviceActivityChecker();
            }, intervalTime);
        },

        clearIntervalActivity() {
            if (this.intervalActivity) {
                clearInterval(this.intervalActivity);
            }
        },

        async cancelImport(item){
            let resp = await this.fetcher({
                url: `/imports.api/cancel/${item.uuid}`,
                method:"PUT"
            });
            this.updateData();
            this.checkActivity();
            await this.eventSynchronizeAllImports();
        }
        
    },
    async mounted(){
        await this.updateData();
        this.checkActivity();
        await this.eventSynchronizeAllImports();
    },
    beforeDestroy() {
        this.clearIntervalActivity();
    },

}
</script>

<style scoped lang="scss">
    /* .request-report{
        overflow: hidden;
        width: 30%;
    }
    .message{
        width: 30%;
        overflow: hidden;
    } */
    .message__container{
        overflow: hidden;
    }

    .pre{
        & .pre__container{
            max-width: 30rem;
            overflow: auto;
            & .span__pre {
                display: block;
                unicode-bidi: embed;
                font-family: monospace;
                /* white-space: pre; */
                white-space: pre-wrap;
            }
        }
        
    }
    
    
</style>